<template>
    <!-- 모바일 -->
    <div v-if="PG_MODE=='M'" :class="'mo-reserve-wrap--survey-form'">
        <div v-if="QUTN_NAME" :class="'mo-reserve-wrap--title'">
            <p>참여하기</p>
        </div>

        <div :class="'mo-reserve-wrap--survey-form-list'" v-for="(surveyItem, idx) in QUTN_ITEMS" :key="idx">

            <div :class="'mo-reserve-wrap--survey-form-title'" :id="surveyItem.QUTN_ITEM_CODE+'_DIV_'+idx">
                <p v-html="surveyItem.QUTN_ITEM_NAME"></p>
            </div>

            <div :class="'mo-reserve-wrap--survey-form-subtext'" v-if="surveyItem.QUTN_ITEM_CONT">
                <p v-html="surveyItem.QUTN_ITEM_CONT"></p>
            </div>

            <div :class="'mo-reserve-wrap--survey-form-a survey-tot'">
                <!-- 라디오 -->
                <v-radio-group 
                    v-model="RADIO_GROUP_SELECTED[idx]" 
                    v-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_10'?true:false"
                    :name="surveyItem.QUTN_ITEM_CODE"
                    @change="fnRadioEvent"
                    :ref="surveyItem.QUTN_ITEM_CODE"
                >
                    <v-radio
                        v-for="(qdItem, index) in surveyItem.QUTN_DETA_ITEMS" 
                        :key="qdItem.QUTN_ITEM_DETL_CODE" 
                        :label="qdItem.QUTN_ITEM_DETL_CONT"
                        :on-icon="'svg-rad-on'"
                        :off-icon="'svg-rad-off'"
                        :value="surveyItem.QUTN_ITEM_CODE+':'+qdItem.QUTN_ITEM_DETL_CODE"
                    >
                    </v-radio>
                </v-radio-group>

                <!-- 체크 -->
                <v-checkbox
                    v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_11'"
                    v-for="(qdItem, index) in surveyItem.QUTN_DETA_ITEMS"
                    :key="qdItem.QUTN_ITEM_DETL_CODE+'_'+index"
                    :label="qdItem.QUTN_ITEM_DETL_CONT"
                    :on-icon="'svg-chk-on'"
                    :off-icon="'svg-chk-off'"
                    class="surveyChkbox"
                    :id="qdItem.QUTN_ITEM_DETL_CODE+'_'+surveyItem.MULTI_TYPE_LIMIT"
                    :name="surveyItem.QUTN_ITEM_CODE"
                    :ref="surveyItem.QUTN_ITEM_CODE"
                    v-model="CHK_GROUP_SELECTED[qdItem.QUTN_ITEM_DETL_CODE]"
                    @click="fnChkEvent"
                >
                </v-checkbox>

                <!-- 셀렉트 -->
                <div class="form-inp pt-0" v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_12'?true:false">
                    <v-autocomplete 
                        :items="surveyItem.QUTN_DETA_ITEMS" 
                        item-text="QUTN_ITEM_DETL_CONT" 
                        item-value="QUTN_ITEM_DETL_CODE" 
                        outlined hide-details
                        placeholder="선택하세요" 
                        v-model="SELECT_GROUP_SELECTED[surveyItem.QUTN_ITEM_CODE]"
                        @change="fnSelectEvent(surveyItem.QUTN_ITEM_CODE)"
                        :name="surveyItem.QUTN_ITEM_CODE"
                        :ref="surveyItem.QUTN_ITEM_CODE"
                    >
                    </v-autocomplete>
                </div>

                <!-- 텍스트 -->
                <!-- <textarea
                    v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_20'?true:false"
                    :counter="200"
                    :name="surveyItem.QUTN_ITEM_CODE"
                    :id="surveyItem.QUTN_ITEM_CODE+'_'+idx"
                    cols="20" rows="3"
                    style="width:100%; border-radius:5px; border:0.5px solid #80808066"
                    counter
                    outlined
                    @blur="fnTxtEvent"
                    @keyup="fnSpDec"
                >
                </textarea> -->

                <v-text-field
                    v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_20'?true:false"
                    counter="200"
                    class="type-line"
                    v-model="VM_TXT_FIELD[surveyItem.QUTN_ITEM_CODE]"
                    :name="surveyItem.QUTN_ITEM_CODE"
                    :id="surveyItem.QUTN_ITEM_CODE+'_'+idx"
                    style="width:100%;"
                    @blur="fnTxtEvent"
                    @keyup="fnSpDec"
                    @click="fnSpDec"
                    :ref="surveyItem.QUTN_ITEM_CODE"
                >
                </v-text-field>

                <!-- 이미지 -->
                <div class="file-upload-wrap" v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_21'?true:false">
                    <div class="file-upload-print">
                        <img 
                            src="@/assets/file_upload_default.png" 
                            alt=""
                            @error="'@/assets/@sample_survey_img.png'" 
                            :id="'previewImg_'+idx"
                        >
                    </div>


                    <!-- <div class="file-upload-txt">
                        이미지 파일을 등록 해주세요.
                    </div> -->
                    <button type="button" class="btn-upload" @click="fnOnClickUpload(idx)" :name="surveyItem.QUTN_ITEM_CODE">이미지 등록</button>
                    <input 
                        :id="'fileInput_'+idx"
                        type="file" 
                        style="visibility: hidden;"
                        accept="image/*"
                        :name="surveyItem.QUTN_ITEM_CODE"
                        @change="fnReadImage"
                    />
                </div>

                <!-- 달력/시간 -->
                <div v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_30'?true:false"> 
                    <div class="mt-1">
                        <div class="calendar-modal">
                            <v-date-picker
                                v-model=SURVEY_DT[idx]
                                full-width
                                no-title 
                                color="#fae100"
                                event-color="#fae100"
                                locale="ko-KR"
                                :first-day-of-week="0"
                                :day-format="mixin_getDate"
                                @change="fnSurveyDate(surveyItem.QUTN_ITEM_CODE, idx)"
                            >
                            </v-date-picker>

                            <div class="pt-2" style="margin-bottom: 5px;">
                                <v-autocomplete 
                                    :items="surveyTimeItems" 
                                    item-text="QUTN_ITEM_DETL_CONT" 
                                    item-value="QUTN_ITEM_DETL_CODE" 
                                    outlined hide-details
                                    placeholder="선택하세요" 
                                    :id="surveyItem.QUTN_ITEM_CODE+'_'+idx"
                                    :name="surveyItem.QUTN_ITEM_CODE"
                                    @blur="fnSurveyTime"
                                    v-model=SURVEY_TIME[idx]
                                >
                                </v-autocomplete>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="PG_MODE=='M' && PAGE_DUB_MODE=='' && PAGE_MODE2!='T'" :class="'mo-reserve-wrap--btn full'" style="margin-top:10vh;" :disabled="surveySaveBtnBool" v-show="BTN_BOOL">
            <button type="button" id="inSurveySaveBtn" @click="fnSurveySaveBtn">제출하기</button>
        </div>
    </div>

    <!-- PC -->
    <ul v-else-if="PG_MODE=='W'">

        <div v-if="QUTN_NAME && PAGE_DUB_MODE=='W'" :class="'reserve-wrap--title'" style="padding-right:60px;">
            <p v-html="QUTN_NAME"></p>
        </div>
        <div v-if="QUTN_CONT && PAGE_DUB_MODE=='W'" :class="'reserve-wrap--title'" style="padding-right: 60px;">
            <h6 v-html="QUTN_CONT"></h6>
        </div>

        <li v-for="(surveyItem, idx) in QUTN_ITEMS" :key="idx">

            <p :class="'survey-qa-list--q'" style="font-size: large; margin-top:17px;">
                <p v-html="surveyItem.QUTN_ITEM_NAME"></p>
            </p>

            <p :class="'survey-qa-list--q--sub'" style="font-size: medium;">
                <p v-html="surveyItem.QUTN_ITEM_CONT"></p>
            </p>

            <div :class="'survey-qa-list--a survey-tot'">
                <!-- 라디오 -->
                <v-radio-group 
                    v-model="RADIO_GROUP_SELECTED[idx]" 
                    v-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_10'?true:false"
                    @change="fnRadioEvent"
                >
                    <v-radio
                        v-for="(qdItem, index) in surveyItem.QUTN_DETA_ITEMS" 
                        :key="qdItem.QUTN_ITEM_DETL_CODE" 
                        :label="qdItem.QUTN_ITEM_DETL_CONT"
                        :on-icon="'svg-rad-on'"
                        :off-icon="'svg-rad-off'"
                        :value="surveyItem.QUTN_ITEM_CODE+':'+qdItem.QUTN_ITEM_DETL_CODE"
                    >
                    </v-radio>
                </v-radio-group>

                <!-- 체크 -->
                <v-checkbox
                    v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_11'"
                    v-for="(qdItem, index) in surveyItem.QUTN_DETA_ITEMS"
                    :key="qdItem.QUTN_ITEM_DETL_CODE+'_'+index"
                    :label="qdItem.QUTN_ITEM_DETL_CONT"
                    :on-icon="'svg-chk-on'"
                    :off-icon="'svg-chk-off'"
                    class="surveyChkbox"
                    :id="qdItem.QUTN_ITEM_DETL_CODE+'_'+surveyItem.MULTI_TYPE_LIMIT"
                    :name="surveyItem.QUTN_ITEM_CODE"
                    v-model="CHK_GROUP_SELECTED[qdItem.QUTN_ITEM_DETL_CODE]"
                    @click="fnChkEvent"
                >
                </v-checkbox>

                <!-- 셀렉트 -->
                <div class="form-inp pt-0" v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_12'?true:false">
                    <v-autocomplete 
                        :items="surveyItem.QUTN_DETA_ITEMS" 
                        item-text="QUTN_ITEM_DETL_CONT" 
                        item-value="QUTN_ITEM_DETL_CODE" 
                        outlined hide-details
                        placeholder="선택하세요" 
                        :name="surveyItem.QUTN_ITEM_CODE"
                        v-model="SELECT_GROUP_SELECTED[surveyItem.QUTN_ITEM_CODE]"
                        @change="fnSelectEvent(surveyItem.QUTN_ITEM_CODE)"
                    >
                    </v-autocomplete>
                </div>

                <!-- 텍스트 -->
                <!-- <textarea
                    v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_20'?true:false"
                    :counter="200"
                    :name="surveyItem.QUTN_ITEM_CODE"
                    :id="surveyItem.QUTN_ITEM_CODE+'_'+idx"
                    cols="20" rows="2"
                    style="width:100%; border-radius:5px; border:0.5px solid #80808066"
                    counter
                    outlined
                    @blur="fnTxtEvent"
                    @keyup="fnSpDec"
                >
                </textarea> -->

                <v-text-field
                    v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_20'?true:false"
                    counter="200"
                    class="type-line"
                    v-model="VM_TXT_FIELD[surveyItem.QUTN_ITEM_CODE]"
                    :name="surveyItem.QUTN_ITEM_CODE"
                    :id="surveyItem.QUTN_ITEM_CODE+'_'+idx"
                    style="width:100%;"
                    @blur="fnTxtEvent"
                    @keyup="fnSpDec"
                    @click="fnSpDec"
                >
                </v-text-field>

                <!-- 이미지 -->
                <div class="file-upload-wrap" v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_21'?true:false">
                    <div class="file-upload-print">
                        <img 
                            src="@/assets/file_upload_default.png" 
                            alt=""
                            @error="'@/assets/@sample_survey_img.png'" 
                            :id="'previewImg_'+idx"
                        >
                    </div>

                    <!-- <div class="file-upload-txt">
                        이미지 파일을 등록 해주세요.
                    </div> -->
                    <button type="button" class="btn-upload" @click="fnOnClickUpload(idx)">이미지 등록</button>

                    <input 
                        :id="'fileInput_'+idx"
                        :name="surveyItem.QUTN_ITEM_CODE"
                        type="file" 
                        style="visibility: hidden;"
                        accept="image/*"
                        @change="fnReadImage"
                    />
                </div>

                <!-- 달력/시간 -->
                <div v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_30'?true:false"> 
                    <div class="mt-1">
                        <div class="calendar-modal">
                            <v-date-picker
                                v-model=SURVEY_DT[idx]
                                full-width
                                no-title 
                                color="#fae100"
                                event-color="#fae100"
                                locale="ko-KR"
                                :first-day-of-week="0"
                                :day-format="mixin_getDate"
                                @change="fnSurveyDate(surveyItem.QUTN_ITEM_CODE, idx)"
                            >
                            </v-date-picker>

                            <div class="pt-2" style="margin-bottom: 5px;">
                                <v-autocomplete 
                                    :items="surveyTimeItems" 
                                    item-text="QUTN_ITEM_DETL_CONT" 
                                    item-value="QUTN_ITEM_DETL_CODE" 
                                    outlined hide-details
                                    placeholder="선택하세요" 
                                    :id="surveyItem.QUTN_ITEM_CODE+'_'+idx"
                                    :name="surveyItem.QUTN_ITEM_CODE"
                                    @blur="fnSurveyTime"
                                    v-model=SURVEY_TIME[idx]
                                >
                                </v-autocomplete>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </li>
    </ul>
        
    <!-- 테블릿 -->
    <div v-else-if="PG_MODE=='T'" class="reserve-form-wrap">
        <div class="reserve-form-wrap--terms">
            <div class="reserve-form-wrap--terms-survey">
                <ul>
                    <li v-for="(surveyItem, idx) in QUTN_ITEMS" :key="idx">
                        
                        <div v-if="surveyItem.QUTN_ITEM_NAME" :class="'reserve-form-wrap--terms-survey--q'">
                            <p v-html="surveyItem.QUTN_ITEM_NAME"></p>
                        </div>

                        <div v-if="surveyItem.QUTN_ITEM_CONT" :class="'reserve-wrap--survey-form-sub'">
                            <p v-html="surveyItem.QUTN_ITEM_CONT"></p>
                        </div>

                        <div :class="'reserve-form-wrap--terms-survey--a survey-tot'">
                            <!-- 라디오 -->
                            <v-radio-group 
                                v-model="RADIO_GROUP_SELECTED[idx]" 
                                v-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_10'?true:false"
                                @change="fnRadioEvent"
                                :name="surveyItem.QUTN_ITEM_CODE"
                                :ref="surveyItem.QUTN_ITEM_CODE"
                            >
                                <v-radio
                                    v-for="(qdItem, index) in surveyItem.QUTN_DETA_ITEMS" 
                                    :key="qdItem.QUTN_ITEM_DETL_CODE" 
                                    :label="qdItem.QUTN_ITEM_DETL_CONT"
                                    :on-icon="'svg-rad-on'"
                                    :off-icon="'svg-rad-off'"
                                    :value="surveyItem.QUTN_ITEM_CODE+':'+qdItem.QUTN_ITEM_DETL_CODE"
                                >
                                </v-radio>
                            </v-radio-group>

                            <!-- 체크 -->
                            <v-checkbox
                                v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_11'"
                                v-for="(qdItem, index) in surveyItem.QUTN_DETA_ITEMS"
                                :key="qdItem.QUTN_ITEM_DETL_CODE+'_'+index"
                                :label="qdItem.QUTN_ITEM_DETL_CONT"
                                :on-icon="'svg-chk-on'"
                                :off-icon="'svg-chk-off'"
                                class="surveyChkbox"
                                :id="qdItem.QUTN_ITEM_DETL_CODE+'_'+surveyItem.MULTI_TYPE_LIMIT"
                                :name="surveyItem.QUTN_ITEM_CODE"
                                :ref="surveyItem.QUTN_ITEM_CODE"
                                v-model="CHK_GROUP_SELECTED[qdItem.QUTN_ITEM_DETL_CODE]"
                                @click="fnChkEvent"
                            >
                            </v-checkbox>

                            <!-- 셀렉트 -->
                            <div class="form-inp pt-0" v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_12'?true:false">
                                <v-autocomplete 
                                    :items="surveyItem.QUTN_DETA_ITEMS" 
                                    item-text="QUTN_ITEM_DETL_CONT" 
                                    item-value="QUTN_ITEM_DETL_CODE" 
                                    outlined hide-details
                                    placeholder="선택하세요" 
                                    v-model="SELECT_GROUP_SELECTED[surveyItem.QUTN_ITEM_CODE]"
                                    @change="fnSelectEvent(surveyItem.QUTN_ITEM_CODE)"
                                    :name="surveyItem.QUTN_ITEM_CODE"
                                    :ref="surveyItem.QUTN_ITEM_CODE"
                                >
                                </v-autocomplete>
                            </div>

                            <!-- 텍스트 -->
                            <!-- <textarea
                                v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_20'?true:false"
                                :counter="200"
                                :name="surveyItem.QUTN_ITEM_CODE"
                                :id="surveyItem.QUTN_ITEM_CODE+'_'+idx"
                                cols="20" rows="2"
                                style="width:100%; border-radius:5px; border:0.5px solid #80808066"
                                counter
                                outlined
                                @blur="fnTxtEvent"
                                @keyup="fnSpDec"
                            >
                            </textarea> -->

                            <v-text-field
                                v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_20'?true:false"
                                counter="200"
                                class="type-line tTypeText"
                                v-model="VM_TXT_FIELD[surveyItem.QUTN_ITEM_CODE]"
                                :name="surveyItem.QUTN_ITEM_CODE"
                                :id="surveyItem.QUTN_ITEM_CODE+'_'+idx"
                                style="width:100%;"
                                @blur="fnTxtEvent"
                                @keyup="fnSpDec"
                                @click="fnSpDec"
                            >
                            </v-text-field>

                            <!-- 이미지 -->
                            <div class="file-upload-wrap" v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_21'?true:false">
                                <div class="file-upload-print">
                                    <img 
                                        src="@/assets/file_upload_default.png" 
                                        alt=""
                                        @error="'@/assets/@sample_survey_img.png'" 
                                        :id="'previewImg_'+idx"
                                        @click="fnOnClickUpload(idx)"
                                        style="width : 100%;"
                                    >
                                </div>

                                <!-- <div class="file-upload-txt">
                                    이미지 파일을 등록 해주세요.
                                </div> -->
                                <!-- <button type="button" class="btn-upload" @click="fnOnClickUpload(idx)">이미지 등록</button> -->

                                <input 
                                    :id="'fileInput_'+idx"
                                    :name="surveyItem.QUTN_ITEM_CODE"
                                    type="file" 
                                    style="visibility: hidden;"
                                    accept="image/*"
                                    @change="fnReadImage"
                                />
                            </div>

                            <!-- 달력/시간 -->
                            <div v-else-if="surveyItem.QUTN_ITEM_TYPE_CD=='QUTN_ITEM_TYPE_CD_30'?true:false"> 
                                <div class="mt-1">
                                    <div class="calendar-modal">
                                        <v-date-picker
                                            v-model=SURVEY_DT[idx]
                                            full-width
                                            no-title 
                                            color="#fae100"
                                            event-color="#fae100"
                                            locale="ko-KR"
                                            :first-day-of-week="0"
                                            :day-format="mixin_getDate"
                                            @change="fnSurveyDate(surveyItem.QUTN_ITEM_CODE, idx)"
                                        >
                                        </v-date-picker>

                                        <div class="pt-2" style="margin-bottom: 5px;">
                                            <v-autocomplete 
                                                :items="surveyTimeItems" 
                                                item-text="QUTN_ITEM_DETL_CONT" 
                                                item-value="QUTN_ITEM_DETL_CODE" 
                                                outlined hide-details
                                                placeholder="선택하세요" 
                                                :id="surveyItem.QUTN_ITEM_CODE+'_'+idx"
                                                :name="surveyItem.QUTN_ITEM_CODE"
                                                @blur="fnSurveyTime"
                                                v-model=SURVEY_TIME[idx]
                                            >
                                            </v-autocomplete>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="mo-reserve-wrap--survey-form-list">
                                    <div class="mo-reserve-wrap--survey-form-a">
                                        <div class="mo-reserve-wrap--reserve">
                                            <div class="mo-reserve-wrap--reserve--time"> 
                                                {{ SURVEY_DT_TIME[idx] }}
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    
</template>

<script>
    import axios from "axios"

    export default {
        name: "Survey",
        props: {
            RESULT_MODE: {
                type: Number,
                default: 1   // 받는 데이터가 없을 경우 default 지정가능
            },
            PAGE_MODE: {
                type: String,
                default: 'T'   // 받는 데이터가 없을 경우 default 지정가능
            },
            PAGE_MODE2: {
                type: String,
                default: 'T'   // 받는 데이터가 없을 경우 default 지정가능
            },
            PAGE_DUB_MODE: {
                type: String,
                default: ''   // 받는 데이터가 없을 경우 default 지정가능
            },
            SURVEY_TYPE: {
                type: String,
                default: ''   // 받는 데이터가 없을 경우 default 지정가능
            },
            SURVEY_AF_DATAS: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                defImgSrc: 'data:image/png;base64,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',
                baseUrl: process.env.VUE_APP_API_URL,
                BTN_BOOL: false,
                ANS_BOOL:true, //답변 조회 여부
                COUNSL_CALL:false,
                surveySaveBtnBool:false,
                SURVEY_TP:this.SURVEY_TYPE,

                CMP_CNSL_ID: '',
                CUST_CNSL_ID: '',
                CMP_ID: '',
                BUSS_CODE: '',
                RES_MODE: this.RESULT_MODE,
                PG_MODE: this.PAGE_MODE,
                SURVEY_PA_AF_DATAS: this.SURVEY_AF_DATAS, //현재 셋팅된 설문 답변 값

                RADIO_GROUP_SELECTED: [],
                CHK_GROUP_SELECTED: [],

                SELECT_GROUP_SELECTED: [],
                DATE_GROUP_SELECTED: [],
                IMG_GROUP_SELECTED: [],
                IMG_FILE_GROUP_SELECTED: [],
                chkGsBool: [],

                TEXT_AREA_VM: [],
                UPLD_GROUP_ID: '',

                menu: [],
                menu1: [],
                SURVEY_DT: [],
                surveyDt: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10),
                SURVEY_TIME: ['00:00'],
                surveyTime: '00:00',
                allowedStep: (m) => m % 1 === 0,
                SURVEY_DT_TIME: [],
                surveyTimeItems: [],

                textareaRules: [
                    v => v.length > 0 || v.length+'자 제한'
                ],

                TIME_DIV_BOOL: [],

                SURVEY_LIST: [],
                QUTN_ITEMS: [],
                PART_TYPE: '', //입주관련 파라미터

                QUTN_NAME: '',
                BUSS_CODE: '',
                BUSS_NAME: '',
                CMP_STDT: '',
                CMP_ENDT: '',
                CMP_ID: '',
                CMP_NAME: '',
                QUTN_CONT: '',
                QUTN_ID: null,
                MKTG_AGRE_YN: '',
                PRSN_AGRE_YN: '',
                PLUS_FRED_KEY: '',
                VM_TXT_FIELD:[],

                QUTN_ITEM_ANS_LIST: '',
                QUTN_ITEM_LIST: [],
                CHK_QUTN_RPLY: [], //라디오
                SEL_QUTN_RPLY: [], //셀렉트
                TXT_QUTN_RPLY: [], //텍스트
                ETC_QUTN_RPLY: [], //체크(다중 선택)
                IMG_QUTN_RPLY: [], //이미지
                IMG_QUTN_RPLY_CHK: [], //이미지 임시체크
                DATE_QUTN_RPLY: [], //달력/시간

                alertMsg: {
                    error: '관리자에게 문의해주세요.',
                    saveYn: '설문 제출을 하시겠습니까?',
                    updateYn: '설문 수정 하시겠습니까?',
                    chkImgFile: '이미지 파일이 아닙니다.',
                    errCustInfo: '고객데이터 정보가 상이합니다.', //이벤트설문 및 사전방문예약 설문시 적용
                    multiTypeLimitChk: '선택 가능 개수를 초과했습니다.',
                },

                MOBI_YN: false,

                W_CMP_CNSL_ID: '',
                W_CUST_CNSL_ID: '',
            }
        },

        mounted() {

            //설문 데이터 초기화
            this.fnRegistAf();

            if (!this.mixin_isEmpty(this.$route.query.cmp_id)) {
                this.CMP_ID = this.$route.query.cmp_id.replace(/[\"\']/gi, '')   //캠페인ID
            }
            if (!this.mixin_isEmpty(this.$route.query.buss_code)) {
                this.BUSS_CODE = this.$route.query.buss_code.replace(/[\"\']/gi, '')   //사업지 코드
            }
            if (!this.mixin_isEmpty(this.$route.query.mktg_agre_yn)) {
                this.MKTG_AGRE_YN = this.$route.query.mktg_agre_yn.replace(/[\"\']/gi, '') //마케팅 동의 여부
            }
            if (!this.mixin_isEmpty(this.$route.query.prsn_agre_yn)) {
                this.PRSN_AGRE_YN = this.$route.query.prsn_agre_yn.replace(/[\"\']/gi, '') //개인정보 수집 동의 여부
            }
            if (!this.mixin_isEmpty(this.$route.query.cust_phone)) {
                this.CUST_PHONE = this.$route.query.cust_phone.replace(/[\"\']/gi, '') //고객 핸드폰번호
            }
            if (!this.mixin_isEmpty(this.$route.query.plus_fred_key)) {
                this.PLUS_FRED_KEY = this.$route.query.plus_fred_key.replace(/[\"\']/gi, '')  //플러스 친구 사용키
            }

            //모바일 여부
            this.MOBI_YN = this.mixin_mobi_yn();
        },

        computed: {
        },

        methods: {

            // 답 초기화
            fnResetAnsw() {
                this.RADIO_GROUP_SELECTED = [];
                this.CHK_GROUP_SELECTED = [];
                this.SELECT_GROUP_SELECTED = [];
                this.VM_TXT_FIELD = [];
                this.SURVEY_DT = [];
                this.SURVEY_TIME = [];
            },

            fnInit() {
                //초반 조회 조건 캠페인 사업지 대상자 핸드폰번호 카카오 플러스인증키가 있을 경우만 설문 조회 가능
                if (!this.mixin_isEmpty(this.CMP_ID)
                    && !this.mixin_isEmpty(this.BUSS_CODE)
                        && !this.mixin_isEmpty(this.CUST_PHONE)
                            && !this.mixin_isEmpty(this.PLUS_FRED_KEY)
                ) {
                    this.fnSurveyList();
                }else{
                    this.common_alert(this.alertMsg.errCustInfo, 'chk');
                }
            },

            //미사전예약 현장방문 설문 함수 호출
            fnVisetSurveyCall(datas) {
                if(!this.mixin_isEmpty(datas)) {
                    this.CMP_ID=datas.CMP_ID;
                    this.QUTN_ID=datas.QUTN_ID;
                    this.ANS_BOOL=datas.ANS_BOOL; //답변 조회 여부
                    this.fnSurveyList();
                }
            },

            //개인상담관리 상담사 설문 호출
            fnCounsSurveyCall(datas) {
                if(!this.mixin_isEmpty(datas)) {
                    this.W_CMP_CNSL_ID=datas.CMP_CNSL_ID;
                    this.W_CUST_CNSL_ID=datas.CUST_CNSL_ID;
                    this.CMP_ID=datas.CMP_ID;
                    this.CUST_PHONE=datas.CUST_PHONE;
                    this.QUTN_ID=datas.QUTN_ID;
                    this.COUNSL_CALL=datas.COUNSL_CALL;
                    this.PLUS_FRED_KEY=datas.PLUS_FRED_KEY;
                    this.ANS_BOOL=datas.ANS_BOOL; //답변 조회 여부
                    this.fnSurveyList();
                }
            },

            //설문 미리보기 함수
            fnSurveyPreview(datas) {
                if(!this.mixin_isEmpty(datas)) {
                    this.QUTN_ID=datas.QUTN_ID;
                    this.ANS_BOOL=datas.ANS_BOOL; //답변 조회 여부
                    this.fnSurveyList();
                }
            },

            fnMultiLimitChk(event) {
                let itemCd='';
                let itemDetaCdCurr='';

                if (this.mixin_isEmpty(event.target.previousSibling.name)) {
                    itemCd = event.target.control.name;
                } else {
                    itemCd = event.target.previousSibling.name;
                }

                let currId='';
                if (this.mixin_isEmpty(event.target.previousSibling.id)) {
                    currId=event.target.control.id;
                    itemDetaCdCurr = currId.split('_');
                } else {
                    currId=event.target.previousSibling.id;
                    itemDetaCdCurr = currId.split('_');
                }

                let curDetaCd='';
                if(itemDetaCdCurr.length>0) {
                    curDetaCd=itemDetaCdCurr[0];
                }
                let itemId='';
                let itemChkLimit=0;
                let itemDetaCd='';
                const chkLang=document.getElementsByName(itemCd);

                let chkCnt=0;
                for (let i = 0; i < chkLang.length; i++) {
                    let element=chkLang[i];

                    itemId=element.id.split('_'); //아이템 상세 코드_체크타입일 경우 체크 제한 개수
                    itemDetaCd=itemId[0];

                    //체크된 부분 카운트
                    if(this.CHK_GROUP_SELECTED[itemDetaCd]) {
                        chkCnt++;
                    }
                }
                
                //체크 리밋 개수
                let limitBool=false;
                if(itemId.length>1) {
                    itemChkLimit=itemId[1];
                    limitBool=true;
                }

                //체크된 부분이 제한 개수를 넘으면
                if(chkCnt>itemChkLimit && limitBool && !this.mixin_isEmpty(itemChkLimit)) {
                    this.CHK_GROUP_SELECTED[curDetaCd]=false;
                    document.getElementById(currId).parentElement.firstChild.classList.remove('svg-chk-on');
                    document.getElementById(currId).parentElement.firstChild.classList.remove('primary--text');
                    document.getElementById(currId).parentElement.firstChild.classList.add('svg-chk-off');
                    this.common_alert(this.alertMsg.multiTypeLimitChk+'\n(선택 가능 개수 : '+itemChkLimit+'개)', 'chk');
                    return false;
                }else{
                    return true;
                }
            },

            fnChkEvent(event) {
                let limitChkBool=true;
                setTimeout(() => limitChkBool=this.fnMultiLimitChk(event), 88);
                setTimeout(() => this.fnEtcChkTO(event, limitChkBool), 222);
            },

            fnEtcChkTO(event, limitChkBool) {
                let itemCd='';
                let itemDetaCdCurr='';

                if (this.mixin_isEmpty(event.target.previousSibling.name)) {
                    itemCd = event.target.control.name;
                } else {
                    itemCd = event.target.previousSibling.name;
                }

                if (this.mixin_isEmpty(event.target.previousSibling.id)) {
                    itemDetaCdCurr = event.target.control.id.split('_');
                } else {
                    itemDetaCdCurr = event.target.previousSibling.id.split('_');
                }
                
                const chkLang=document.getElementsByName(itemCd);
                
                if (chkLang.length > 0 && limitChkBool) {
                    let itemDetaCds='';
                    for (let i = 0; i < chkLang.length; i++) {
                        let element=chkLang[i];

                        let itemId=element.id.split('_'); //아이템 상세 코드_체크타입일 경우 체크 제한 개수
                        let itemDetaCd=itemId[0];

                        if (this.CHK_GROUP_SELECTED[itemDetaCd]) {
                            itemDetaCds += itemDetaCd + '&';
                        }
                    }

                    let etcVal=itemDetaCds.substring(0, itemDetaCds.length - 1);
                    let etcChkBoxData = itemCd + ':' + etcVal;

                    let bool = true;
                    //0보다 클 경우 itemCd 조회 후 해당 detaCd sett (ex:itemCd:itemDetaCd,... 형태)

                    for (let k = 0; k < this.ETC_QUTN_RPLY.length; k++) {
                        const eqr = this.ETC_QUTN_RPLY[k];
                        if (eqr.includes(itemCd)) {
                            this.ETC_QUTN_RPLY.splice(k, 1);
                            if(!this.mixin_isEmpty(etcVal)) {
                                this.ETC_QUTN_RPLY.push(etcChkBoxData);
                            }
                            bool = false;

                            //값 변경 감지
                            this.fnSaveBtnChng(false);
                        }
                    }

                    //해당 itemCd가 존재하지 않는다면
                    if (bool) {
                        this.ETC_QUTN_RPLY.push(etcChkBoxData);
                        //값 변경 감지
                        this.fnSaveBtnChng(false);
                    }
                }
            },

            fnRadioEvent(value) {
                let etcCdArr = [];
                if (!this.mixin_isEmpty(value)) {
                    etcCdArr = value.split(':');
                } else {
                    return;
                }

                let bool = true;
                if (this.CHK_QUTN_RPLY.length > 0) {
                    this.CHK_QUTN_RPLY.forEach((cqr, i) => {
                        if (cqr.match(etcCdArr[0])) {
                            this.CHK_QUTN_RPLY.splice(i, 1); //해당 배열 삭제 후
                            this.CHK_QUTN_RPLY.push(value); //다시 지정
                            bool = false;
                        }
                    })

                    //해당 itemCd가 존재하지 않는다면
                    if (bool) {
                        this.CHK_QUTN_RPLY.push(value);
                    }

                    //값 변경 감지
                    this.fnSaveBtnChng(false);

                } else {
                    this.CHK_QUTN_RPLY.push(value);
                }

            },

            fnSelectEvent(itemCd) {
                const val = this.SELECT_GROUP_SELECTED[itemCd];

                const fVal = itemCd + ':' + val;

                let bool = true;
                if (this.SEL_QUTN_RPLY.length > 0) {
                    this.SEL_QUTN_RPLY.forEach((sqr, i) => {
                        if (sqr.match(itemCd)) {
                            this.SEL_QUTN_RPLY.splice(i, 1); //해당 배열 삭제 후

                            if(!this.mixin_isEmpty(val)) {
                                this.SEL_QUTN_RPLY.push(fVal); //다시 지정
                            }
                            bool = false;
                        }
                    })

                    //해당 itemCd가 존재하지 않는다면
                    if (bool) {
                        this.SEL_QUTN_RPLY.push(fVal);
                    }

                    //값 변경 감지
                    this.fnSaveBtnChng(false);

                } else {
                    if(!this.mixin_isEmpty(val)) {
                        this.SEL_QUTN_RPLY.push(fVal);
                    }
                }
            },

            fnSpDec(e) {
                let obj=e.currentTarget;
                let itemCd = obj.name;
                let id=e.currentTarget.id;
                let ids=id.split('_');
                let idx=id.split('_')[1];

                if(!this.mixin_isEmpty(this.VM_TXT_FIELD[itemCd])) {
                    obj.value=this.VM_TXT_FIELD[itemCd];
                    obj.value=this.mixin_sp_replace(e);
        
                    if(e.currentTarget.value.length>200) {
                        obj.value=obj.value.substring(0, 200);
                    }
                    this.VM_TXT_FIELD[itemCd]=obj.value;
                }
            },

            fnTxtEvent(event) {
                //특정 문자 제거
                this.fnSpDec(event);

                if(!this.mixin_isEmpty(event.currentTarget.name)) {
                    const itemCd = event.currentTarget.name;
                    const idx = event.currentTarget.id.split('_')[1];
                    let obj=event.currentTarget;
        
                    if(obj.value.length>200) {
                        this.VM_TXT_FIELD[itemCd]=obj.value.substring(0, 200);
                    }

                    let contVal=this.fnEncode(this.VM_TXT_FIELD[itemCd]);
                    let val = itemCd + ':' + contVal;

                    let contValBool=false;
                    if(!this.mixin_isEmpty(contVal)) {
                        contValBool=true;
                    }

                    let bool = true;
                    if (this.TXT_QUTN_RPLY.length > 0) {
                        this.TXT_QUTN_RPLY.forEach((dgs, i) => {
                            if (dgs.match(itemCd)) {
                                
                                this.TXT_QUTN_RPLY.splice(i, 1); //해당 배열 삭제 후

                                if(contValBool) {
                                    this.TXT_QUTN_RPLY.push(val); //다시 지정
                                }

                                bool = false;

                                //값 변경 감지
                                this.fnSaveBtnChng(false);
                            }
                        })

                        //해당 itemCd가 존재하지 않는다면
                        if (bool) {

                            if(contValBool) {
                                this.TXT_QUTN_RPLY.push(val);
                            }

                            //값 변경 감지
                            this.fnSaveBtnChng(false);
                        }

                    } else if(contValBool) {
                        this.TXT_QUTN_RPLY.push(val);
                    }
                }
            },

            /**
            * XSS Encode
            */
            fnEncode(strText) {

                if (strText === "" || strText == null) {
                    return strText;
                }

                strText = strText.replaceAll("(", "&#40;");
                strText = strText.replaceAll(")", "&#41;");
                strText = strText.replaceAll("[", "&#91;");
                strText = strText.replaceAll("]", "&#93;");
                strText = strText.replaceAll("&", "&amp;");
                strText = strText.replaceAll('"', "&quot;");
                strText = strText.replaceAll("'", "&apos;");
                strText = strText.replaceAll("\r", "<br/>");
                strText = strText.replaceAll("\n", "<p>");
                strText = strText.replaceAll("<", "&lt;");
                strText = strText.replaceAll(">", "&gt;");
                strText = strText.replaceAll(",", "&#44;");


                return strText;
            },

            /**
            * XSS Decode
            */
            fnDecode(strText) {

                //값존재유무 체크
                if (strText === "" || strText == null) {
                    return strText;
                }
                strText = strText.toString();

                //문자열 길이가 4이상일 경우만 처리
                if (strText.length <= 3) {
                    return strText;
                }
                //순서바뀌면 안나옴
                strText = strText.replaceAll("&lt;", "<");
                strText = strText.replaceAll("&gt;", ">");
                strText = strText.replaceAll("&amp;", "&");
                strText = strText.replaceAll("&quot;", '"');
                strText = strText.replaceAll("&apos;", "'");
                strText = strText.replaceAll("<br/>", "\r");
                strText = strText.replaceAll("<p>", "\n");
                strText = strText.replaceAll("&#91;", "[");
                strText = strText.replaceAll("&#93;", "]");
                strText = strText.replaceAll("&#40;", "(");
                strText = strText.replaceAll("&#41;", ")");
                strText = strText.replaceAll("&#44;", ",");

                return strText;
            },

            fnTimeSett(idx) {

                this.surveyTimeItems = [];

                const maxMinu = 60 * 24;
                // let cnslTimeUnit = 10; // 10분 간격
                let cnslTimeUnit = 60; // 10분 간격
                let visiMinu = maxMinu / cnslTimeUnit;
                let timeRange = visiMinu;

                let choosDay = new Date(this.SURVEY_DT[idx] + ' ' + '00:00');

                for (let i = 0; i < timeRange; i++) {

                    const hour = choosDay.getHours() > 9 ? '' + choosDay.getHours() : '0' + choosDay.getHours();
                    const minute = choosDay.getMinutes() > 9 ? '' + choosDay.getMinutes() : '0' + choosDay.getMinutes();

                    const timeValue = hour + ':' + minute;
                    this.surveyTimeItems.push(timeValue);

                    choosDay.setMinutes(choosDay.getMinutes() + cnslTimeUnit);
                }
            },

            fnSurveyDate(itemCd, idx) {
                this.fnTimeSett(idx);

                if (!this.mixin_isEmpty(this.SURVEY_DT[idx])) {
                    this.TIME_DIV_BOOL[idx] = true;
                }

                if (!this.mixin_isEmpty(this.SURVEY_DT[idx])) {

                    if(this.mixin_isEmpty(this.SURVEY_TIME[idx])) {
                        this.SURVEY_TIME[idx]='00:00';
                    }

                    this.SURVEY_DT_TIME[idx] = this.SURVEY_DT[idx] + ' ' + this.SURVEY_TIME[idx];
                }

                if (!this.mixin_isEmpty(this.SURVEY_DT[idx]) && !this.mixin_isEmpty(this.SURVEY_TIME[idx])) {
                    this.SURVEY_DT_TIME[idx] = this.SURVEY_DT[idx] + ' ' + this.SURVEY_TIME[idx];

                    let val = itemCd + ':' + this.SURVEY_DT_TIME[idx];

                    let bool = true;
                    if (this.DATE_QUTN_RPLY.length > 0) {
                        this.DATE_QUTN_RPLY.forEach((dgs, i) => {
                            if (dgs.match(itemCd)) {
                                this.DATE_QUTN_RPLY.splice(i, 1); //해당 배열 삭제 후
                                this.DATE_QUTN_RPLY.push(val); //다시 지정

                                //해당 itemCd가 존재한다면
                                bool = false;
                            }
                        })

                        //해당 itemCd가 존재하지 않는다면
                        if (bool) {
                            this.DATE_QUTN_RPLY.push(val);
                        }

                    } else {
                        this.DATE_QUTN_RPLY.push(val);
                    }
                }

                //값 변경 감지
                this.fnSaveBtnChng(false);

                setTimeout(() => $('.v-btn--active').removeClass('theme--light'), 1);
                setTimeout(() => $('.v-btn--active').removeClass('v-btn--active'), 1);
            },

            fnSurveyTime(event) {
                const itemCd = event.currentTarget.name;
                const idx = event.currentTarget.id.split('_')[1];

                if (!this.mixin_isEmpty(this.SURVEY_DT[idx]) && !this.mixin_isEmpty(this.SURVEY_TIME[idx])) {
                    this.SURVEY_DT_TIME[idx] = this.SURVEY_DT[idx] + ' ' + this.SURVEY_TIME[idx];

                    let val = itemCd + ':' + this.SURVEY_DT_TIME[idx];

                    let bool = true;
                    if (this.DATE_QUTN_RPLY.length > 0) {
                        this.DATE_QUTN_RPLY.forEach((dgs, i) => {
                            if (dgs.match(itemCd)) {
                                this.DATE_QUTN_RPLY.splice(i, 1); //해당 배열 삭제 후
                                this.DATE_QUTN_RPLY.push(val); //다시 지정

                                //해당 itemCd가 존재한다면
                                bool = false;
                            }
                        })

                        //해당 itemCd가 존재하지 않는다면
                        if (bool) {
                            this.DATE_QUTN_RPLY.push(val);
                        }

                    } else {
                        this.DATE_QUTN_RPLY.push(val);
                    }
                }

            },

            fnReadImage(event) {
                
                //itemCode : file 객체
                const itemCd = event.currentTarget.name;
                this.IMG_FILE_GROUP_SELECTED[itemCd] = event.target.files;

                //파일이 존재하면...
                let iqrBool=true;
                if (this.IMG_FILE_GROUP_SELECTED[itemCd].length > 0) {
                    this.IMG_QUTN_RPLY.forEach((iqr, i)=> {
                        if(iqr.includes(itemCd)) {                        
                            this.IMG_QUTN_RPLY[i] = itemCd;
                            iqrBool=false;
                        }
                    });

                    if(this.IMG_QUTN_RPLY.length==0 || iqrBool) {
                    this.IMG_QUTN_RPLY.push(itemCd);
                    }
                }else{
                    this.IMG_QUTN_RPLY.forEach((iqr, i)=> {
                        if(iqr.includes(itemCd)) {                      
                            this.IMG_QUTN_RPLY.splice(i, 1);
                        }
                    });
                }


                let bool = true;
                if (this.IMG_GROUP_SELECTED.length > 0) {

                    this.IMG_GROUP_SELECTED.forEach((igs, i) => {
                        if (igs.match(itemCd)) {
                            this.IMG_GROUP_SELECTED.splice(i, 1); //해당 배열 삭제

                            if (this.IMG_FILE_GROUP_SELECTED[itemCd].length > 0) {
                                this.IMG_GROUP_SELECTED.push(itemCd); //다시 지정

                                //해당 itemCd가 존재한다면
                                bool = false;
                            }
                            
                        }
                    })

                    //해당 itemCd가 존재하지 않는다면
                    if (bool) {
                        this.IMG_GROUP_SELECTED.push(itemCd);
                    }

                } else {
                    if (this.IMG_FILE_GROUP_SELECTED[itemCd].length > 0) {
                        this.IMG_GROUP_SELECTED.push(itemCd);
                    }
                }

                if (!this.mixin_isEmpty(event)) {
                    const input = event.target;
                    const id = event.currentTarget.id;
                    const idIdx = id.split('_')[1];

                    if (!this.mixin_isEmpty(input.files) && input.files.length > 0) {
                        if (this.fileExtTypeChk(input.files[0].name)) { //.png,.jpg,.gif,.jpeg........ 이미지 타입 확장자 유무 체크
                            if (input.files && input.files[0]) {
                                var reader = new FileReader();
                                reader.onload = function (e) {
                                    document.getElementById('previewImg_' + idIdx).src = e.target.result;
                                }
                                reader.readAsDataURL(input.files[0]);
                            } else {
                                document.getElementById('previewImg_' + idIdx).src = this.defImgSrc;
                            }
                        } else {
                            this.common_alert(this.alertMsg.chkImgFile, 'chk');
                        }
                    } else {
                        document.getElementById('previewImg_' + idIdx).src = this.defImgSrc;
                    }

                    //값 변경 감지
                    this.fnSaveBtnChng(false);
                }
            },

            async fnSurveyList() {

                this.fnResetAnsw();

                let requestData = {
                    headers: {
                        METHOD: 'list',
                    },
                    sendData: {}
                };

                requestData.headers["URL"] = "/api/hlw/advanReserv/campaign/manage/survey/item";

                // sendData 세팅
                requestData.sendData["CMP_ID"] = this.CMP_ID;
                requestData.sendData["QUTN_ID"] = this.QUTN_ID;
                requestData.sendData["BUSS_CODE"] = this.BUSS_CODE;
                requestData.sendData["PLUS_FRED_KEY"] = this.PLUS_FRED_KEY;
                requestData.sendData["CUST_USER_KEY"] = this.PLUS_FRED_KEY;
                requestData.sendData["CUST_PHONE"] = this.CUST_PHONE;
                requestData.sendData["CMP_TYPE_CD"] = this.SURVEY_TP;
                requestData.sendData["USE_YN"] = 'Y';

                if(this.ANS_BOOL) { //답변 조회 여부
                    requestData.sendData["ANS_BOOL"] = 'Y';

                    if(!this.mixin_isEmpty(this.W_CMP_CNSL_ID)) {
                        requestData.sendData["CMP_CNSL_ID"] = this.W_CMP_CNSL_ID;
                    }

                    if(!this.mixin_isEmpty(this.W_CUST_CNSL_ID)) {
                        requestData.sendData["CUST_CNSL_ID"] = this.W_CUST_CNSL_ID;
                    }

                }else{
                    requestData.sendData["ANS_BOOL"] = 'N';
                }
                
                if(this.COUNSL_CALL) { //상담사 호출 여부
                    requestData.sendData["COUNSL_CALL"] = 'Y';
                }else{
                    requestData.sendData["COUNSL_CALL"] = 'N';
                }

                let responseGridList=await this.common_postCall(requestData, false);
                let resHeader=responseGridList.HEADER;
                let resData=responseGridList.DATA;
                let cmpData=responseGridList.CMP_DATA;
                let surveyAnsData=responseGridList.SURVEY_ANS_DATA; //사전예약 설문 응답 데이터
                let custSurveyAnsData=responseGridList.CUST_SURVEY_ANS_DATA;    //현장방문 설문 응답 데이터

                // 데이터 조회 오류 시 alert
                if (resHeader.ERROR_FLAG) {
                    if (!this.mixin_isEmpty(responseGridList.HEADER.MSG)) {
                        this.common_alert(responseGridList.HEADER.MSG, "error");
                    } else {
                        this.common_alert(this.alertMsg.error, "error");
                    }
                    setTimeout(() => this.fnCloseSurvey(), 1500);
                    return;
                }

                this.SURVEY_LIST=resData;

                if (this.mixin_isEmpty(this.SURVEY_LIST) || this.SURVEY_LIST.length == 0) {
                    this.BTN_BOOL=false;
                    this.PAGE_MODE=null;
                    let datas={
                        QUTN_ID:null,
                    };
                    this.fnSurveyCmpDatas(datas);
                } else {

                    if (!this.mixin_isEmpty(this.PG_MODE) && this.PG_MODE === 'M') {
                        this.BTN_BOOL=true;
                    } else {
                        this.BTN_BOOL=false;
                    }

                    //설문 데이터가 존재할 경우
                    this.SURVEY_LIST.forEach(element => {
                        this.QUTN_NAME=element.QUTN_NAME;
                        this.BUSS_NAME=element.BUSS_NAME;
                        this.CMP_STDT=element.CMP_STDT;
                        this.CMP_ENDT=element.CMP_ENDT;
                        this.CMP_NAME=element.CMP_NAME;
                        this.QUTN_CONT=element.QUTN_CONT;
                        this.QUTN_ID=element.QUTN_ID;

                        this.QUTN_ITEMS=element.QUTN_ITEMS;

                        //입주관련 파라미터
                        this.PART_TYPE=element.PART_TYPE;

                        let datas={
                            BUSS_NAME:this.BUSS_NAME,
                            CMP_STDT:this.CMP_STDT,
                            CMP_ENDT:this.CMP_ENDT,
                            CMP_NAME:this.CMP_NAME,
                            QUTN_ID:this.QUTN_ID,
                        };
                        this.fnSurveyCmpDatas(datas);
                    });

                    //이벤트 설문 여부 체크
                    let duplChkBool=false;
                    if(this.SURVEY_TP!='TYPE-01') {
                        duplChkBool=true;
                    }

                    let duplBool=false;
                    if(!this.mixin_isEmpty(cmpData)) {
                        if(cmpData.length>0) {
                            let dupYn=cmpData[0].DUP_YN;
                            if(dupYn=='Y') {
                                duplBool=true;
                            }else{
                                duplBool=false;
                            }
                        }
                    }

                    //중복참여가 아닐 경우만 실행
                    if(!duplBool) {

                        let ansDatas = '';

                        if(!this.mixin_isEmpty(surveyAnsData)) {
                            ansDatas = surveyAnsData;
                        }

                        if(!this.mixin_isEmpty(custSurveyAnsData)) {
                            if(this.PG_MODE == 'W') {
                                ansDatas = custSurveyAnsData;
                            }
                        }

                        //상담 고객관련 데이터
                        if (!this.mixin_isEmpty(custSurveyAnsData) && custSurveyAnsData.length > 0 && !this.mixin_isEmpty(ansDatas)) {
                            this.CUST_CNSL_ID=ansDatas[0].CUST_CNSL_ID;
                        }
        
                        //캠페인 고객관련 데이터
                        if (!this.mixin_isEmpty(surveyAnsData) && surveyAnsData.length > 0) {
                            this.CMP_CNSL_ID=ansDatas[0].CMP_CNSL_ID;
                            this.UPLD_GROUP_ID=ansDatas[0].UPLD_GROUP_ID;
        
                            setTimeout(() => this.fnAnsDataProcc(ansDatas[0]), 200);

                            //중복참여가 불가능 할 경우 버튼 제어
                            this.BTN_BOOL=false;
                        }
                        //상위 창에 정답 데이터 여부 전달
                        this.fnSurveyCmpAnsDatas(ansDatas);
                    }
                }
            },

            fnAnsDataProcc(custAnsData) {
                let qutnItemList = custAnsData.QUTN_ITEM_LIST; //아이템 코드 목록
                let chkQutnRply = custAnsData.CHK_QUTN_RPLY; //라디오 > QUTN_ITEM_TYPE_CD_10
                let etcQutnRply = custAnsData.ETC_QUTN_RPLY; //체크박스 > QUTN_ITEM_TYPE_CD_11
                let imgQutnRply = custAnsData.IMG_QUTN_RPLY; //이미지 > QUTN_ITEM_TYPE_CD_21
                let selQutnRply = custAnsData.SEL_QUTN_RPLY; //셀렉트박스 > QUTN_ITEM_TYPE_CD_12
                let txtQutnRply = custAnsData.TXT_QUTN_RPLY; //텍스트박스 > QUTN_ITEM_TYPE_CD_20
                let dateQutnRply = custAnsData.DATE_QUTN_RPLY; //달력/시간 > QUTN_ITEM_TYPE_CD_30

                if (!this.mixin_isEmpty(qutnItemList)) {
                    if(qutnItemList.indexOf(',') <= -1) {
                        this.QUTN_ITEM_LIST.push(qutnItemList);
                    }else{
                        this.QUTN_ITEM_LIST = qutnItemList.split(',');
                    }
                }else{
                    this.QUTN_ITEM_LIST=[];
                }
                if (!this.mixin_isEmpty(chkQutnRply)) {
                    if(chkQutnRply.indexOf(',') <= -1) {
                        this.CHK_QUTN_RPLY.push(chkQutnRply);
                    }else{
                        this.CHK_QUTN_RPLY = chkQutnRply.split(',');
                    }
                }else{
                    this.CHK_QUTN_RPLY=[];
                    this.RADIO_GROUP_SELECTED=[];
                }
                if (!this.mixin_isEmpty(etcQutnRply)) {
                    if(etcQutnRply.indexOf(',') <= -1) {
                        this.ETC_QUTN_RPLY.push(etcQutnRply);
                    }else{
                        this.ETC_QUTN_RPLY = etcQutnRply.split(',');
                    }
                }else{
                    this.ETC_QUTN_RPLY=[];
                    this.CHK_GROUP_SELECTED=[];
                }
                if (!this.mixin_isEmpty(imgQutnRply)) {
                    if(imgQutnRply.indexOf(',') <= -1) {
                        this.IMG_QUTN_RPLY.push(imgQutnRply);
                    }else{
                        this.IMG_QUTN_RPLY = imgQutnRply.split(',');
                    }
                }else{
                    this.IMG_QUTN_RPLY=[];
                }
                if (!this.mixin_isEmpty(selQutnRply)) {
                    if(selQutnRply.indexOf(',') <= -1) {
                        this.SEL_QUTN_RPLY.push(selQutnRply);
                    }else{
                        this.SEL_QUTN_RPLY = selQutnRply.split(',');
                    }
                }else{
                    this.SEL_QUTN_RPLY=[];
                    this.SELECT_GROUP_SELECTED=[];
                }
                if (!this.mixin_isEmpty(txtQutnRply)) {
                    if(txtQutnRply.indexOf(',') <= -1) {
                        this.TXT_QUTN_RPLY.push(txtQutnRply);
                    }else{
                        this.TXT_QUTN_RPLY = txtQutnRply.split(',');
                    }
                }else{
                    this.TXT_QUTN_RPLY=[];
                }
                if (!this.mixin_isEmpty(dateQutnRply)) {
                    if(dateQutnRply.indexOf(',') <= -1) {
                        this.DATE_QUTN_RPLY.push(dateQutnRply);
                    }else{
                        this.DATE_QUTN_RPLY = dateQutnRply.split(',');
                    }
                }else{
                    this.DATE_QUTN_RPLY=[];
                    this.SURVEY_DT=[];
                    this.TIME_DIV_BOOL=[];
                    this.SURVEY_TIME=[];
                }

                this.QUTN_ITEMS.forEach((surveyItem, idx) => {
                    let itemCd = surveyItem.QUTN_ITEM_CODE; //아이템 코드
                    let surveyType = surveyItem.QUTN_ITEM_TYPE_CD; //유형코드

                    // EX)
                    // CHK_QUTN_RPLY:"388-227:388-227-489,388-219:388-219-478"
                    // ETC_QUTN_RPLY:"388-228:388-228-491&388-228-492,388-220:388-220-482&388-220-483"
                    // IMG_QUTN_RPLY:"388-223:10798,388-222:10799"
                    // QUTN_ITEM_LIST:"388-219,388-220,388-221,388-222,388-223,388-224,388-225,388-226,388-227,388-228,388-229,388-230"
                    // SEL_QUTN_RPLY:"388-229:388-229-495,388-226:388-226-484"
                    // TXT_QUTN_RPLY:"388-221:AASDFasdfasdfasdfasdf"
                    // DATE_QUTN_RPLY:"388-224:2022-10-18 00:40,388-225:2022-10-31 11:20"

                    switch (surveyType) {
                        case 'QUTN_ITEM_TYPE_CD_10': //라디오
                            this.CHK_QUTN_RPLY.forEach(radio => {
                                if (radio.includes(itemCd)) {
                                    this.RADIO_GROUP_SELECTED[idx] = radio;
                                }
                            });
                            break;
                        case 'QUTN_ITEM_TYPE_CD_11': //체크박스

                            this.CHK_GROUP_SELECTED=[];
                            this.ETC_QUTN_RPLY.forEach(one => {
                                const etcQutnRplyItemDetaArr = one.split(':');
                                const etcQutnRplyDetaArr = etcQutnRplyItemDetaArr[1].split('&');

                                for (let i = 0; i < etcQutnRplyDetaArr.length; i++) {
                                    const etcQutnRplyDeta = etcQutnRplyDetaArr[i];
                                    
                                    this.CHK_GROUP_SELECTED[etcQutnRplyDeta] = false;
                                    let chkBoxId = etcQutnRplyDeta + '_' + surveyItem.MULTI_TYPE_LIMIT;

                                    document.getElementById(chkBoxId).parentElement.firstChild.classList.remove('svg-chk-on');
                                    document.getElementById(chkBoxId).parentElement.firstChild.classList.remove('primary--text');
                                    document.getElementById(chkBoxId).parentElement.firstChild.classList.add('svg-chk-off');
                                }

                                if (one.includes(itemCd)) { //itemCode
                                    etcQutnRplyDetaArr.forEach(two => { //detaCode
                                        this.CHK_GROUP_SELECTED[two] = true;
                                        let chkBoxId = two + '_' + surveyItem.MULTI_TYPE_LIMIT;
                                        
                                        document.getElementById(chkBoxId).parentElement.firstChild.classList.add('svg-chk-on');
                                        document.getElementById(chkBoxId).parentElement.firstChild.classList.add('primary--text');
                                        document.getElementById(chkBoxId).parentElement.firstChild.classList.remove('svg-chk-off');
                                    });
                                }
                            });
                            break;
                        case 'QUTN_ITEM_TYPE_CD_12': //셀렉트
                            this.SEL_QUTN_RPLY.forEach(sel => {
                                if (sel.includes(itemCd)) {
                                    const selDetaCd = sel.split(':');
                                    this.SELECT_GROUP_SELECTED[itemCd] = selDetaCd[1];
                                }
                            });
                            break;
                        case 'QUTN_ITEM_TYPE_CD_30': //달력/시간
                            this.DATE_QUTN_RPLY.forEach(date => {
                                if (date.includes(itemCd)) {
                                    const selDtTimeArr = date.split(' '); //0=388-224:2022-10-18, 1=00:40
                                    const selItemDate = selDtTimeArr[0].split(':');
                                    const dayDt = selItemDate[1];

                                    this.SURVEY_DT[idx] = dayDt;
                                    this.TIME_DIV_BOOL[idx] = true;
                                    this.fnTimeSett(idx); //시간 셀렉트박스 시간 셋팅
                                    this.SURVEY_TIME[idx] = selDtTimeArr[1];
                                }
                            });
                            break;
                        default:
                            break;
                    }

                });
                
                //이미지 태그 셋팅
                setTimeout(() => this.fnImgSett(), 777);
            },

            fnImgSett() {
                this.QUTN_ITEMS.forEach((surveyItem, idx) => {
                    let itemCd = surveyItem.QUTN_ITEM_CODE; //아이템 코드
                    let surveyType = surveyItem.QUTN_ITEM_TYPE_CD; //유형코드

                    switch (surveyType) {
                        case 'QUTN_ITEM_TYPE_CD_21': //이미지
                            this.IMG_QUTN_RPLY.forEach(img => {
                                if (img.includes(itemCd)) {
                                    let imgTag = document.getElementById('previewImg_' + idx);
                                    const imgKey = img.split(':');
                                    if(imgKey.length > 1) {
                                        if(!this.mixin_isEmpty(imgKey[1])) {
                                            imgTag.src = this.baseUrl + 'api/file/hlw/images/' + imgKey[1];
                                        }
                                    }
                                }
                            });

                            if(this.IMG_QUTN_RPLY.length==0) {
                                let imgTag=document.getElementById('previewImg_' + idx);
                                imgTag.src=this.defImgSrc;
                            }

                            break;
                        case 'QUTN_ITEM_TYPE_CD_20': //텍스트
                            this.TXT_QUTN_RPLY.forEach(txt => {
                                if (txt.includes(itemCd)) {
                                    const txtDetaCd = txt.split(':');
                                    let txtTag=document.getElementById(itemCd + '_' + idx);
                                    if(txtDetaCd.length>1) {
                                        txtTag.value=this.fnDecode(txtDetaCd[1]);
                                        this.VM_TXT_FIELD[txtDetaCd[0]]=txtTag.value;
                                    }
                                }
                            });

                            if(this.TXT_QUTN_RPLY.length==0) {
                                let txtTag=document.getElementById(itemCd + '_' + idx);
                                txtTag.value='';
                            }

                            break;
                        default:
                            break;
                    }
                });
            },

            // 답변 널체크 검수
            fnSurveyAnsChk() {
                this.QUTN_ITEM_LIST = [];
                this.QUTN_ITEMS.forEach(element => {
                    this.QUTN_ITEM_LIST.push(element.QUTN_ITEM_CODE);
                });

                let ansChkBool=true;

                for (let index = 0; index < this.QUTN_ITEM_LIST.length; index++) {

                    let chkRpStr=this.CHK_QUTN_RPLY.join();
                    let selRpStr=this.SEL_QUTN_RPLY.join();
                    let txtRpStr=this.TXT_QUTN_RPLY.join();
                    let etcRpStr=this.ETC_QUTN_RPLY.join();
                    let imgRpStr=this.IMG_QUTN_RPLY.join();
                    let dateRpStr=this.DATE_QUTN_RPLY.join();

                    const rpStrs=chkRpStr+','+selRpStr+','+txtRpStr+','+etcRpStr+','+imgRpStr+','+dateRpStr;

                    if(!rpStrs.includes(this.QUTN_ITEM_LIST[index])) {
                        ansChkBool=false;
                        if(!this.mixin_isEmpty(document.getElementsByName(this.QUTN_ITEM_LIST[index])) && document.getElementsByName(this.QUTN_ITEM_LIST[index]).length>0) {
                            this.common_alert('답변 안 하신 질문이 있습니다.', 'chk');
                            $("div[id^='"+this.QUTN_ITEM_LIST[index]+"_DIV']")[0].scrollIntoView(true);
                            document.getElementsByName(this.QUTN_ITEM_LIST[index])[0].focus();
                        }
                        return ansChkBool;
                    }
                }

                return ansChkBool;
            },

            fnSurveySaveBtn(req) {
                if(this.fnSurveyAnsChk()) {
                    this.common_confirm(this.alertMsg.saveYn, this.fnImgSave, req, null, null, 'chk');
                }
            },

            fnSaveBtnChng(bool) {
                this.surveySaveBtnBool=bool;
            },

            fnLodingBar(bool) {
                this.mixin_pg_bar(bool);
            },

            async fnImgSave(req) {

                if(!this.mixin_isEmpty(req)) {
                    if(!this.mixin_isEmpty(req.sendData)) {
                        this.CUST_PHONE = req.sendData.CUST_PHONE;
                    }

                    if(this.PG_MODE == 'W' && !this.mixin_isEmpty(req.BUSS_CODE) && !this.mixin_isEmpty(req.CUST_PHONE)) {
                        if(this.mixin_isEmpty(this.CMP_CNSL_ID)) {
                            this.CMP_CNSL_ID = req.CMP_CNSL_ID;
                        }
                        if(this.mixin_isEmpty(this.BUSS_CODE)) {
                            this.BUSS_CODE = req.BUSS_CODE;
                        }
                        if(this.mixin_isEmpty(this.CUST_PHONE)) {
                            this.CUST_PHONE = req.CUST_PHONE;
                        }
                    }
                }

                this.$emit("surveySaveBf", 1);
                this.fnSaveBtnChng(true);

                let requestData = {
                    headers: {
                        SERVICE: 'files',
                        METHOD: 'upload',
                        URL: this.baseUrl + "api/files/upload",
                        AUTHORIZATION: this.mixin_getToken(),
                        UPLOAD_URI: "/api/files/upload",
                        DOWNLOAD_URI: "/api/files/download",
                        DIR: '/campaign/manage/survey/images/', //파일 저장 경로
                        TEMP_DIR: '/campaign/manage/survey/images/temp',
                        PROC_ID: this.user_id,
                        PATH_TYPE: 'images',
                        UPLD_GROUP_ID: this.UPLD_GROUP_ID,
                        'Content-Type': 'multipart/form-data',
                    },
                    sendData: {}
                };

                const formData = new FormData();
                const imgList = this.IMG_GROUP_SELECTED;

                let fileUpdBool = false;
                if (imgList.length > 0) {
                    let relTypeCds = [];
                    for (let index = 0; index < imgList.length; index++) {

                        const files = this.IMG_FILE_GROUP_SELECTED[imgList[index]];
                        if (files.length > 0) {
                            fileUpdBool = true; //한개라도 있을 경우 api 호출
                            const file = files[0];
                            if (this.fileExtTypeChk(file.name)) { //.png,.jpg,.gif,.jpeg........ 이미지 타입 확장자 유무 체크
                                formData.append('fileList', file);

                                let sknObj = {};
                                sknObj['key'] = file.name;
                                sknObj['value'] = 'REL_TYPE_CD_12';
                                relTypeCds.push(sknObj);
                            }
                        }
                    }

                    if (fileUpdBool) {
                        let svcPrvdCd = '';
                        if (this.baseUrl.indexOf('local') !== -1) {
                            svcPrvdCd = 'SVC_PRVD_CD_01';
                        } else {
                            svcPrvdCd = 'SVC_PRVD_CD_02';
                        }

                        formData.append('SVC_PRVD_CD', svcPrvdCd); //서비스 제공자 코드
                        formData.append('REL_TABLE_CD', 'REL_TABLE_CD_05'); //연결 테이블 코드
                        formData.append('REL_TYPE_CDS', JSON.stringify(relTypeCds)); //연결 타입 코드

                        axios.post(requestData.headers.URL, formData, {
                            headers: requestData.headers
                        }).then(response => {

                            const returnDatas = response.data;
                            const retDatas = returnDatas.data;

                            if (returnDatas.responseMessage === '정상') { //이미지 등록 정상 후 처리
                                
                                let imgQutnRply = [];
                                for (let index = 0; index < retDatas.length; index++) {
                                    const element = retDatas[index];

                                    const fileK = element.upldId;
                                    const upldName = element.upldName;
                                    const fileGroupK = element.upldGroupId;

                                    //저장 후 파일별 key가 생성됨
                                    if (!this.mixin_isEmpty(fileK)) {
                                        let val = this.IMG_GROUP_SELECTED[index] + ':' + fileK;

                                        this.IMG_QUTN_RPLY.forEach((element, i) => {
                                            if(element.includes(this.IMG_GROUP_SELECTED[index])) {
                                                this.IMG_QUTN_RPLY[i]=val;
                                            }
                                        });
                                    }

                                    //그룹키의 경우 신규 저장시 api 서버에서 생성되나 신규생성이 아닌 수정일 경우 기존 그룹키를 가져와서 셋팅
                                    requestData.sendData["UPLD_GROUP_ID"] = fileGroupK;
                                    this.UPLD_GROUP_ID = fileGroupK;
                                }

                                this.fnSurveySave(requestData);

                            } else {
                                return this.common_alert(this.alertMsg.error, "error");
                            }

                        }).catch(error => {
                            return error.message;
                        })
                    } else {
                        this.fnSurveySave(requestData);
                    }
                } else {
                    this.fnSurveySave(requestData);
                }
            },

            fileExtTypeChk(fileName) {
                let boolParam = false;
                for (let index = 0; index < this.geImgExtArry.length; index++) {
                    if (fileName.toLowerCase().indexOf(this.geImgExtArry[index].toLowerCase()) !== -1) {
                        boolParam = true;
                    }
                }
                return boolParam;
            },

            async fnSurveySave(requestData) {
                requestData = {
                    headers: {
                        METHOD: 'list',
                    },
                    sendData: {}
                };

                requestData.headers["URL"] = "/api/hlw/advanReserv/campaign/manage/survey/regist";

                // sendData 세팅
                requestData.sendData["PART_TYPE"] = this.mixin_isEmpty(this.PART_TYPE) ? null : this.PART_TYPE;
                requestData.sendData["CMP_CNSL_ID"] = this.CMP_CNSL_ID;
                requestData.sendData["CUST_CNSL_ID"] = this.CUST_CNSL_ID;
                requestData.sendData["MKTG_AGRE_YN"] = this.MKTG_AGRE_YN;
                requestData.sendData["PRSN_AGRE_YN"] = this.PRSN_AGRE_YN;
                requestData.sendData["CMP_ID"] = this.CMP_ID;
                requestData.sendData["BUSS_CODE"] = this.BUSS_CODE;
                requestData.sendData["USER_ID"] = this.user_id;
                requestData.sendData["QUTN_ID"] = this.QUTN_ID;

                requestData.sendData["CUST_PHONE"] = this.CUST_PHONE.replaceAll(/-/gi, '');

                if((!this.mixin_isEmpty(this.PAGE_MODE2) && this.PAGE_MODE2 == 'M') || this.PG_MODE == 'W') {
                    requestData.sendData["PG_MODE"] = this.PG_MODE;
                }
                requestData.sendData["CUST_USER_KEY"] = this.PLUS_FRED_KEY; //카카오 개인 key
                requestData.sendData["PLUS_FRED_KEY"] = this.PLUS_FRED_KEY;

                if(this.mixin_isEmpty(requestData.sendData["UPLD_GROUP_ID"])) {
                    requestData.sendData["UPLD_GROUP_ID"]=this.UPLD_GROUP_ID;
                }

                this.QUTN_ITEM_LIST = [];
                this.QUTN_ITEMS.forEach(element => {
                    this.QUTN_ITEM_LIST.push(element.QUTN_ITEM_CODE);
                });

                requestData.sendData["QUTN_ITEM_LIST"] = this.QUTN_ITEM_LIST.join(); //아이템 코드 목록

                this.CHK_QUTN_RPLY=this.fnRplArrRebatch(this.QUTN_ITEM_LIST, this.CHK_QUTN_RPLY);
                requestData.sendData["CHK_QUTN_RPLY"] = this.CHK_QUTN_RPLY.join(); //라디오형 아이템 코드:값

                this.SEL_QUTN_RPLY=this.fnRplArrRebatch(this.QUTN_ITEM_LIST, this.SEL_QUTN_RPLY);
                requestData.sendData["SEL_QUTN_RPLY"] = this.SEL_QUTN_RPLY.join(); //셀렉트형 아이템 코드:값
                
                this.TXT_QUTN_RPLY=this.fnRplArrRebatch(this.QUTN_ITEM_LIST, this.TXT_QUTN_RPLY);
                requestData.sendData["TXT_QUTN_RPLY"] = this.TXT_QUTN_RPLY.join(); //텍스트형 아이템 코드:값
                
                this.IMG_QUTN_RPLY=this.fnRplArrRebatch(this.QUTN_ITEM_LIST, this.IMG_QUTN_RPLY);
                requestData.sendData["IMG_QUTN_RPLY"] = this.IMG_QUTN_RPLY.join(); //이미지형 아이템 코드:값(이미지 key)
                
                this.ETC_QUTN_RPLY=this.fnRplArrRebatch(this.QUTN_ITEM_LIST, this.ETC_QUTN_RPLY);
                requestData.sendData["ETC_QUTN_RPLY"] = this.ETC_QUTN_RPLY.join(); //체크박스형 아이템 코드:값
                
                this.DATE_QUTN_RPLY=this.fnRplArrRebatch(this.QUTN_ITEM_LIST, this.DATE_QUTN_RPLY);
                requestData.sendData["DATE_QUTN_RPLY"] = this.DATE_QUTN_RPLY.join(); //달력/시간 아이템 코드:값

                if (this.mixin_isEmpty(requestData.sendData["UPLD_GROUP_ID"])) {
                    requestData.sendData["UPLD_GROUP_ID"] = this.UPLD_GROUP_ID;
                }

                var _ua = window.navigator.userAgent || window.navigator.vgjendor || window.opera;
                requestData.sendData["DEVICE_MODEL"]=_ua;

                let responseGridList = await this.common_postCall(requestData);
                let resHeader = responseGridList.HEADER;
                let resData = responseGridList.DATA;

                // 데이터 조회 오류 시 alert
                if (resHeader.ERROR_FLAG) {
                    if (!this.mixin_isEmpty(responseGridList.HEADER.MSG)) {
                        this.common_alert(responseGridList.HEADER.MSG, "error");
                    } else {
                        this.common_alert(this.alertMsg.error, "error");
                    }
                    setTimeout(() => this.fnCloseSurvey(), 1500);
                    this.fnSaveBtnChng(false);
                    return;
                }else{
                    if (resData.length > 0) {
                        const data = resData[0];
                        this.CMP_CNSL_ID = data.CMP_CNSL_ID;
    
                        if (!this.mixin_isEmpty(this.RES_MODE)) {
                            this.$emit("surveyEvent", resData);
                        }
                    }
                    this.fnSaveBtnChng(false);
                }
            },

            fnRplArrRebatch(qutnItemList, qutnRply) {
                let rplyArr=[];
                qutnItemList.forEach((itemCode, i) => {
                    qutnRply.forEach((item, k) => {
                        if(item.includes(itemCode)) {
                            rplyArr.push(item);
                        }
                    });
                });
                return rplyArr;
            },

            fnCloseSurvey() {
                this.$emit("closeSurvey");
            },

            fnSurveyCmpDatas(datas) {
                this.$emit("surveyCmpDatas", datas);
            },

            fnSurveyCmpAnsDatas(cmpAnsData) {
                this.$emit("surveyCmpAnsDatas", cmpAnsData);
            },

            fnOnClickUpload(idx) {
                let myInput = document.getElementById("fileInput_" + idx);
                myInput.click();
            },

            fnRegistAf() {
                this.CMP_CNSL_ID = '';
                this.UPLD_GROUP_ID = '';
                this.QUTN_ITEM_LIST = [];
                this.CHK_QUTN_RPLY = []; //라디오
                this.SEL_QUTN_RPLY = []; //셀렉트
                this.TXT_QUTN_RPLY = []; //텍스트
                this.IMG_QUTN_RPLY = []; //이미지
                this.ETC_QUTN_RPLY = []; //체크(다중 선택)
                this.DATE_QUTN_RPLY = []; //달력/시간
                this.IMG_QUTN_RPLY_CHK = []; //이미지 임시체크
            },
        },
    };
</script>

<style>
    .reserve-wrap--survey-form-sub {
        color: grey;
        font-size: large;
        padding: 5px 0 5px 0;
        margin: 5px 0 5px 0;
    }

    .reserve-wrap--survey-form-a {
        padding: 5px 0 15px 0;
    }

    .mo-reserve-wrap--survey-form {
        font-family: 'Spoqa Han Sans Neo', 'sans-serif';
    }

    .reserve-form-wrap--terms-survey--a > .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot > input {
        font-size: 34px;
        font-weight: 300;
        letter-spacing: 7px;
        margin-bottom: 12px;
    }

    .v-input--checkbox > .v-input__control > .v-input__slot > .v-input--selection-controls__input > .primary--text {
        filter: opacity(0.35) drop-shadow(0 0 0 #fae100);
    }

    .v-input--checkbox > .v-input__control > .v-input__slot > .v-input--selection-controls__input > .v-input--selection-controls__ripple {
        height: 34px;
        width: 34px;
        top: calc(50% - 24px);
        left: calc(50% - 24px);
        margin: 7;
        border-radius: 20%;
    }

    .v-input--checkbox > .v-input__control > .v-input__slot > .v-input--selection-controls__input > .v-input--selection-controls__ripple:hover {
        color: #00000000 !important;
    }

    .v-radio > .v-input--selection-controls__input > .v-input--selection-controls__ripple {
        height: 34px;
        width: 34px;
        top: calc(50% - 24px);
        left: calc(50% - 24px);
        margin: 7;
        border-radius: 50%;
    }

    .v-radio > .v-input--selection-controls__input > .v-input--selection-controls__ripple:hover {
        color: #00000000 !important;
    }
</style>
